module.exports = {
  'Cortina_Vertical_Blanca': true,
  'blanco': true,
  'natte-colorin-amarillo': true,
  'natte-volcánico': true,
  'Cortina_Vertical_beige': true,
  'bronce': true,
  'natte-colorin-azul': true,
  'natural': true,
  'Cortina_Vertical_marron': true,
  'deco-blanco-beige': true,
  'natte-colorin-mandarina': true,
  'negro': true,
  'Cortina_Vertical_negra': true,
  'deco-blanco-blanco': true,
  'natte-colorin-verde': true,
  'outlet-negro-verde': true,
  'bicolor_blanco_blanco_arena': true,
  'deco-blanco-gris': true,
  'natte-corteza': true,
  'outlet-sombra-gris': true,
  'black-out-beige': true,
  'deco-negro-negro': true,
  'natte-costa': true,
  'verso-blanco-beige': true,
  'black-out-blanco': true,
  'natte-beige-beige': true,
  'natte-cuenca': true,
  'verso-blanco-blanco': true,
  'black-out-gris': true,
  'black-out-gris-topo': true,
  'natte-blanco-blanco': true,
  'natte-glaciar': true,
  'verso-blanco-gris': true,
  'black-out-natural': true,
  'natte-blanco-gris': true,
  'natte-negro-negro': true,
  'black-out-negro': true,
  'natte-chocolate-bronce': true,
  'natte-pantano': true,
  'natte-desierto': true,
  'natte.estepa': true,
  'natte-meseta': true,
  'natte-llanura': true,
  'natte-blanco-beige': true,
  'verso-chocolate-bronce': true,
  'deco-chocolate-bronce': true,
  'poliscreen-lino': true,
  'poliscreen-crudo': true,
  'poliscreen-gris-claro': true,
  'poliscreen-gris-oscuro': true,
  fallbackRender: '/static/images/render_demo.jpg',
  fallback_barral: '/static/images/renders/Cortina_barral_blackout-textil.jpg',
  fallback_mosquitera: '/static/images/renders/fallback_mosquitero.jpg',
  fallback_duo: '/static/images/renders/fallback_duo.jpg',
  fallback_roller: '/static/images/renders/fallback_roller.jpg',
  fallback_vertical: '/static/images/renders/fallback_vertical.jpg',
  fallback_orientales: '/static/images/renders/fallback_panelesorientales.jpg',
}



//////////////////
// WEBPACK FOOTER
// ./helpers/renders.js
// module id = z8Sg
// module chunks = 15